<template>
  <div class="change">
    <button :class="{ active: $route.query.style_list === 'table' }" @click="pushParams('table')">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="18" height="4" fill="#BDBDBD" />
        <rect y="7" width="18" height="4" fill="#BDBDBD" />
        <rect y="14" width="18" height="4" fill="#BDBDBD" />
      </svg>
    </button>
    <button :class="{ active: $route.query.style_list === 'grid' }" @click="pushParams('grid')">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect y="6.77777" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect y="13.5555" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="6.77769" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="6.77769" y="6.77777" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="6.77769" y="13.5555" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="13.5556" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="13.5556" y="6.77777" width="4.44446" height="4.44446" fill="#BDBDBD" />
        <rect x="13.5556" y="13.5555" width="4.44446" height="4.44446" fill="#BDBDBD" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonChangeStyleList',
  methods: {
    pushParams(parameter) {
      let query = Object.assign({}, this.$route.query)
      query['style_list'] = parameter
      let local = localStorage.getItem('queryParams')
      local = local ? JSON.parse(localStorage.getItem('queryParams')) : {}
      local[this.$route.name] = query
      localStorage.setItem('queryParams', JSON.stringify(local))
      this.$router.push({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
.change {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 10px;
  padding: 5px;
  background: #ffffff;
  border-radius: 10px;
  align-items: center;
  height: max-content;
  width: max-content;
  button {
    height: max-content;
    line-height: 1;
    padding: 6px 10px;
    border-radius: 10px;
    &.active {
      background: #277faf;
      svg {
        rect {
          fill: #ffffff;
        }
      }
    }
  }
}
</style>
